module.exports = __webpack_public_path__ + "assets/img/12.39f93637.jpg";